class CartMini extends HTMLElement {
    constructor() {
        super();

        Shopify.money_format =
            '{{amount_no_decimals_with_comma_separator}}' +
            ' ' +
            Shopify.currency.active;
        Shopify.formatMoney = function (cents, format) {
            if (typeof cents == 'string') {
                cents = cents.replace('.', '');
            }
            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = format || this.money_format;

            function defaultOption(opt, def) {
                return typeof opt == 'undefined' ? def : opt;
            }

            function formatWithDelimiters(
                number,
                precision,
                thousands,
                decimal
            ) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.'),
                    dollars = parts[0].replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        '$1' + thousands
                    ),
                    cents = parts[1] ? decimal + parts[1] : '';

                return dollars + cents;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        };

        let addButtons = document.querySelectorAll('.cart-suggestions .add');
        addButtons.forEach((button) => {
            button.addEventListener('click', this.addItemToCart.bind(this));
        });

        let closeButton = document.querySelector('.mini-cart .close');
        if (closeButton) {
            closeButton.addEventListener('click', this.closeCart);
        }

        this.suggestionsInitialized = false;
        this.loadCart();
    }

    async loadCart() {
        try {
            let headers = new Headers();
            headers.append('Pragma', 'no-cache');
            headers.append('Cache-Control', 'no-cache');
            headers.append('Expires', '0');

            let options = {
                method: 'GET',
                headers: headers,
            };
            await fetch('/cart.js?timestamp=' + new Date().getTime(), options)
                .then((response) => {
                    return response.json();
                })
                .then((data) => {
                    if (data.items.length) {
                        let itemNumber = 0;
                        document
                            .querySelector('.mini-cart .text .empty')
                            .classList.remove('show');
                        document
                            .querySelector('.mini-cart .text .full')
                            .classList.add('show');

                        document.querySelector('.cart-content').innerHTML = '';
                        data.items.forEach(function (product, index) {
                            document.querySelector('.cart-content').innerHTML +=
                                `
                        <div class="cart-item item-${product.id}" data-id="${product.id}">
                            <div class="image">
                                <a href="${product.url}">
                                    <img src="${product.featured_image.url}" loading="lazy" alt="${product.product_title}" width="${product.featured_image.width}" height="${product.featured_image.height}">
                                </a>
                            </div>
                            <div class="info">
                                <span class="name">${product.title}</span>
                                <div class="price">
                                    <span class="quantity">${product.quantity}</span> X ` +
                                Shopify.formatMoney(product.line_price) +
                                `
                                </div>
                                <a href="javascript:" data-id="${product.id}" class="add" rel="nofollow">Add</a> <span class="separator"> | </span>
                                <a href="javascript:" data-id="${product.id}" class="remove" rel="nofollow">Remove</a>
                            </div>
                        </div>
                    `;

                            itemNumber += product.quantity;
                        });

                        document.querySelector(
                            '.mini-cart .text .number'
                        ).innerHTML = itemNumber;

                        let checkoutButton = document.querySelector(
                            '.mini-cart .checkout-action'
                        );
                        if (checkoutButton) {
                            checkoutButton.classList.remove('disabled');
                        }
                    } else {
                        document
                            .querySelector('.mini-cart .text .empty')
                            .classList.add('show');
                        document
                            .querySelector('.mini-cart .text .full')
                            .classList.remove('show');

                        document.querySelector(
                            '.mini-cart .cart-content'
                        ).innerHTML = '';

                        let checkoutButton = document.querySelector(
                            '.mini-cart .checkout-action'
                        );
                        if (checkoutButton) {
                            checkoutButton.classList.add('disabled');
                        }
                    }

                    let addButtons =
                        document.querySelectorAll('.mini-cart .add');

                    let removeButtons =
                        document.querySelectorAll('.mini-cart .remove');

                        addButtons.forEach((button) => {
                        button.addEventListener(
                            'click',
                            this.addItemToCart.bind(this)
                        );
                    });

                    removeButtons.forEach((button) => {
                        button.addEventListener(
                            'click',
                            this.removeItemFromCart.bind(this)
                        );
                    });

                    let quantities = document.querySelectorAll(
                        '.mini-cart .quantity'
                    );
                    let itemCount = 0;
                    quantities.forEach((quantity) => {
                        itemCount += parseInt(quantity.innerHTML);
                    });
                    document.querySelector('#cart-item-count').innerHTML =
                        'Bag (' + itemCount + ')';

                    document.querySelector(
                        'sticky-header .mobileHeader .left'
                    ).innerHTML = itemCount;

                    document
                        .querySelector('sticky-header .structure .menu-right')
                        .classList.add('show');

                    this.observe();

                    document.body.classList.remove('mobile-mini-cart-full');
                    if (
                        document.querySelector('.mini-cart .cart-content')
                            .childElementCount > 0
                    ) {
                        document.body.classList.add('mobile-mini-cart-full');
                    }

                    window.localStorage.setItem('cart-count', data.item_count);

                    this.removeVariationDefaultTitle();
                    this.checkSuggestions();
                });
        } catch (err) {}
    }

    async addDiscount() {
        fetch(`/discount/CLOSEFRIENDS`)
            .then(function () {
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: {},
                    }),
                });
            })
            .catch(function (error) {
                console.error('Error:', error);
            });
    }

    observe() {
        const observer = new MutationObserver(function (mutations_list) {
            mutations_list.forEach(function (mutation) {
                if (mutation.type == 'childList') {
                    document.body.classList.remove('mobile-mini-cart-full');
                    if (
                        document.querySelector('.mini-cart .cart-content')
                            .childElementCount > 0
                    ) {
                        document.body.classList.add('mobile-mini-cart-full');
                    }
                }
            });
        });
        observer.observe(document.querySelector('.cart-content'), {
            subtree: false,
            childList: true,
        });
    }

    removeVariationDefaultTitle() {
        let variations = document.querySelectorAll('.variation');
        variations.forEach((variation) => {
            if (variation.innerHTML == 'Default Title') {
                variation.remove();
            }
        });
    }

    checkSuggestions() {
        if (this.suggestionsInitialized) {
            return;
        }
        this.suggestionsInitialized = true;

        let currentSecondaries = document.querySelectorAll(
            '.mini-cart .secondary'
        );

        let currentCartItems = document.querySelectorAll(
            '.mini-cart .cart-item'
        );
        currentCartItems.forEach((product) => {
            let id = product.getAttribute('data-id');
            let suggestion = document.querySelector('.product-' + id);
            if (suggestion) {
                suggestion.remove();
            }
        });

        currentSecondaries = document.querySelectorAll('.mini-cart .secondary');

        let index = 0;
        let secondariesArrayIndex = Array(currentSecondaries.length)
            .fill(0)
            .map(() => index++);
        let shuffled = secondariesArrayIndex
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);

        currentSecondaries.forEach((secondary) => {
            secondary.classList.remove('show');
            secondary.classList.add('hide');
        });

        let mainPresent = document.querySelector('.productThumbnail.main');

        if (currentSecondaries.length >= 2) {
            currentSecondaries[shuffled[0]].classList.add('show');
            currentSecondaries[shuffled[0]].classList.remove('hide');
            currentSecondaries[shuffled[1]].classList.add('show');
            currentSecondaries[shuffled[1]].classList.remove('hide');
        }

        if (!mainPresent && currentSecondaries.length >= 3) {
            currentSecondaries[shuffled[2]].classList.add('show');
            currentSecondaries[shuffled[2]].classList.remove('hide');
        }

        if (document.querySelectorAll('.mini-cart .secondary').length == 0) {
            document.querySelector('.cart-suggestions').remove();
        }
    }

    removeItemFromCart(e) {
        let id = e.target.getAttribute('data-id');
        let info = e.target.closest('.info');
        let cartQuantity = info.querySelector('.quantity');

        let quantity = 0;
        if (cartQuantity) {
            quantity = Math.max(0, parseInt(cartQuantity.innerHTML) - 1);
        }

        let removeData = {
            id: id,
            quantity: quantity,
        };
        let scope = this;

        fetch('/cart/change.js', {
            body: JSON.stringify(removeData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest',
            },
            method: 'POST',
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                let item = document.querySelector(`.cart-item.item-${id}`);
                scope.loadCart();
            })
            .catch(function (err) {
                /* uh oh, we have error. */
                console.error(err);
            });
    }

    addItemToCart(e) {
        let id = e.target.getAttribute('data-id');

        let addData = {
            items: [
                {
                    id: id,
                    quantity: 1,
                },
            ],
        };
        let scope = this;

        fetch('/cart/add.js', {
            body: JSON.stringify(addData),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'xmlhttprequest',
            },
            method: 'POST',
        })
            .then((response) => {
                return response.json();
            })
            .then((response) => {
                scope.loadCart();
            })
            .catch(function (err) {
                /* uh oh, we have error. */
                console.error(err);
            });
    }

    show(force) {
        document.body.classList.toggle('cart-opened');

        if (force) {
            document.body.classList.add('cart-opened');
        }

        document.body.classList.remove('search-opened');
        document.body.classList.remove('menu-opened');

        let mobileMenuOpener = document.querySelector('.mobileMenuOpener');

        if (isTouchDevice()) {
            if (mobileMenuOpener.innerHTML == 'Close') {
                mobileMenuOpener.innerHTML = 'Menu';
            }
        }

        this.scroll(0, 0);
    }

    closeCart() {
        document.body.classList.remove('cart-opened');
    }
}

customElements.define('cart-mini', CartMini);
